type StarRatingProps = {
  className?: string;
  max?: number;
  rating: number;
};

export function StarRating({
  className,
  max = 5,
  rating,
}: StarRatingProps) {
  return (
    <span
      aria-label={`${rating} out of ${max} stars`}
      className={className}
    >
      {Array.from({ length: max }, (_, index) => {
        const filled = index < Math.floor(rating);

        return (
          <svg
            aria-hidden="true"
            className={`oac-star ${filled ? "oac-star--filled" : "oac-star--empty"}`}
            height="16"
            key={index}
            viewBox="0 0 24 24"
            width="16"
          >
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill={filled ? "currentColor" : "none"}
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </svg>
        );
      })}
    </span>
  );
}
